/**
 * Custom fetch wrapper for API calls
 * Adds base URL and common headers
 */
import { getApiUrl } from '../config';
const API_BASE_URL = getApiUrl();
export const customFetch = async (url, options) => {
    const response = await fetch(`${API_BASE_URL}${url}`, {
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers,
        },
    });
    if (!response.ok) {
        const error = await response.json().catch(() => ({ message: response.statusText }));
        throw new Error(error.message || `Request failed: ${response.statusText}`);
    }
    const data = await response.json();
    return { status: response.status, data };
};
export default customFetch;
